<template>
  <section class="section gallery" :class="{'gallery--full':model.fullWidht}" :id="`uuid-${model.uuid}`">
    <div
      class="section__container gallery__container"
      :class="model.fullWidht ? 'section__container--full' : ''"
    >
      <div class="gallery__shape-nav" ref="shapeNav" v-if="showDots"></div>
      
      <div>
        <hooper
          :group="`carousel-${model.uuid}`"
          :ref="`carousel-${model.uuid}`"
          :itemsToShow="1"
          :centerMode="true"
          :wheelControl="false"
          @slide="updateCarousel"
        >
          <hooper-slide v-for="(item, index) in model.galleryItems" :key="item.uuid" :index="index" class="gallery__img-slide"
                        :class="{'gallery__img-slide--mobile-vertical': model.mobileVertical}">
            <slide-img-video-advanced
              :item="item.media"
              :itemMobile="item.mediaMobile"
              :itemAltText="item.altImage"
              :hideGradient="item.hideGradient"
              :slide-num="slidenum"
              :current-slide="index"
              :audioVideo="true"
              :vimeoControls="item.vimeoControls"
              @slide-img-video-mounted="updateCarouselIndex(index)"
            />
          </hooper-slide>
          
          <hooper-pagination :class='showControls' slot="hooper-addons" v-show="showDots"></hooper-pagination>
        </hooper>
        <hooper :group="`carousel-${model.uuid}`"
                :itemsToShow="1"
                :centerMode="true"
                :wheelControl="false"
                :mouse-drag="false"
                :touch-drag="false">
          <hooper-slide v-for="(item, index) in model.galleryItems" :key="item.uuid + '_caption' " :index="index">
            <p class="text--body gallery__caption" v-if="item.caption">{{ item.caption }}</p>
          </hooper-slide>
        </hooper>
      </div>
      <div class="gallery_content">
        <div class="galley__actions">
          <button
            class="gallery__nav-button gallery__nav-button--prev"
            v-show="showPrev"
            @click.prevent="slidePrev"
            type="button"
          >
            <i class="icon icon-arrow-sx">
              <msg id="common.carousel.previous.aria" cssClass="show-for-sr"/>
            </i>
          </button>
          
          <button
            class="gallery__nav-button gallery__nav-button--next"
            v-show="showNext"
            @click.prevent="slideNext"
            type="button"
          >
            <i class="icon icon-arrow-dx">
              <msg id="common.carousel.next.aria" cssClass="show-for-sr"/>
            </i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 - Gallery
 **/

import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
import SlideImgVideoAdvanced from "../SlideImgVideoAdvanced/SlideImgVideoAdvanced.vue";
import {
  Hooper,
  Slide as HooperSlide,
  Pagination as HooperPagination
} from "hooper";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  
  name: "CarouselV2",
  data: function () {
    return {
      slidenum: 0,
      carouselIndex: 0
    };
  },
  components: {
    Hooper,
    HooperPagination,
    HooperSlide,
    SlideImgVideoAdvanced
  },
  computed: {
    showDots() {
      let childElement = this.model.galleryItems;
      return !!(childElement && childElement.length > 1);
    },
    showPrev() {
      return this.slidenum !== 0;
    },
    showNext() {
      let childElement = this.model.galleryItems;
      
      return !!(childElement && this.slidenum !== childElement.length - 1);
    },
    showControls() {
      return this.model.galleryItems && this.model.galleryItems[this.carouselIndex].vimeoControls ? 'controls-on' : 'controls-off';
    }
  },
  methods: {
    showCurrentSlide(event) {
      return (this.slidenum = event.currentSlide);
    },
    slidePrev() {
      this.$refs[`carousel-${this.model.uuid}`].slidePrev();
    },
    slideNext() {
      this.$refs[`carousel-${this.model.uuid}`].slideNext();
    },
    updateCarousel(payload) {
      this.slidenum = payload.currentSlide;
    },
    updateCarouselIndex(index) {
      this.carouselIndex = index;
    }
  },
  mounted() {
    this.$emit('slide-img-video-mounted');
  }
};
</script>
